import React, { useState } from "react";
import BackIcon from "@styles/all-images/icons/back-button.svg";
import HeaderComponent from "@components/common/Header/Header";
import SearchIcon from "@styles/all-images/icons/search.svg";
import ArrowDownIcon from "@styles/all-images/icons/chevron-down-grey.svg";
import LiveChatIcon from "@styles/all-images/icons/livechatblue.svg";
import PhoneIcon from "@styles/all-images/icons/phoneblue.svg";
import EmailIcon from "@styles/all-images/icons/emailblue.svg";
import FlogoIcon from "@styles/all-images/images/Avatar.png";
import ViewTermsSheetModal from "@/pages/TierConfiguration/ViewTermsSheetModal";
import TierConfigurationRejectionReason from "@/pages/TierConfiguration/TierConfigurationRejectionReason";

const TierConfigurationModule = () => {
  const [isViewTermsSheetModalOpen, setIsViewTermsSheetModalOpen] =
    useState(false);
  const [expandedSection, setExpandedSection] = useState("T1");
  const [searchTerm, setSearchTerm] = useState("");
  const [isRejectionModalOpen, setIsRejectionModalOpen] = useState(false);
  const [activeTier, setActiveTier] = useState(1);

  const handleCloseTermsSheet = () => {
    setIsViewTermsSheetModalOpen(false); // Fixed: Close the terms sheet modal correctly
  };

  const handleCloseRejectionModal = () => {
    setIsRejectionModalOpen(false);
  };

  const handleRejectionSubmit = () => {
    setIsRejectionModalOpen(false);
  };

  const tiers = [
    {
      id: "T1",
      title: "GreenTech Solutions",
      items: Array(10).fill({
        name: "FuelCap Pty Ltd.",
        logo: FlogoIcon,
      }),
    },
    {
      id: "T2",
      title: "SolarBright Energy",
      items: [],
    },
    {
      id: "T3",
      title: "EcoBuild Industries",
      items: [],
    },
    {
      id: "T4",
      title: "BlueSky Logistics",
      items: [],
    },
    {
      id: "T5",
      title: "NextGen Petroleum",
      items: [],
    },
  ];

  return (
    <div className="tw-relative">
      <HeaderComponent />
      <div className="tw-fixed tw-h-[68px] tw-top-[80px] tw-w-full tw-z-10">
        <div className="tw-px-8 tw-pt-4 tw-bg-white tw-border-b tw-border-[#E9EAEB]">
          <div className="tw-flex tw-justify-between tw-items-center">
            <div className="tw-flex tw-items-center">
              <a href="/">
                <img src={BackIcon} alt="Back Icon" />
              </a>
              <h1 className="tw-text-[22px] tw-ml-4 tw-font-semibold tw-text-[#232323]">
                Contacts
              </h1>
            </div>
          </div>
          <div className="tw-flex tw-items-center tw-mt-4">
            {[
              "Tier 1",
              "Tier 2",
              "Tier 3",
              "Tier 4",
              "Tier 5",
              "Tier 6",
              "Tier 7",
            ].map((tier, index) => (
              <button
                key={index}
                className={`tw-border tw-px-4 tw-py-2 
            ${activeTier === index + 1 ? "tw-text-[#146C94] tw-border-b-4 tw-border-b-[#146C94]" : "tw-border-b-[#ffffff]"}
            focus:tw-border--b-[#146C94] tw-border-b-4`}
                onClick={() => setActiveTier(index + 1)} // Update the active button on click
              >
                {tier}
              </button>
            ))}
          </div>
        </div>
      </div>
      {/* Main Content */}
      <div className="tw-p-6 tw-mt-[197px] tw-gap-6 tw-flex-col tw-flex">
        <div className="tw-relative">
          <input
            type="text"
            placeholder="Search"
            className="tw-pl-10 tw-pr-4 tw-py-2 tw-border tw-border-[#E9EAEB] tw-shadow tw-rounded-lg tw-w-64 tw-focus:outline-none tw-focus:ring-2 tw-focus:ring-blue-500"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <img
            src={SearchIcon}
            alt="Search Icon"
            className="tw-absolute tw-left-3 tw-top-2.5 tw-h-5 tw-w-5 tw-text-gray-400"
          />
        </div>
        <div>
          <div>
            <div className="tw-full">
              {tiers.map((tier) => (
                <div
                  key={tier.id}
                  className="tw-rounded-lg tw-overflow-hidden tw-bg-[#FFFFFF] tw-border tw-border-[#E9EAEB]  tw-shadow-sm tw-my-3"
                >
                  <button
                    onClick={() =>
                      setExpandedSection(
                        expandedSection === tier.id ? "" : tier.id,
                      )
                    }
                    className={`tw-w-full tw-flex tw-items-center tw-justify-between tw-p-4 tw-text-left tw-transition-colors 
    ${expandedSection === tier.id ? "tw-bg-[#ECF1F8] tw-text-[#232323]" : ""}`} // Add this line for background color change
                  >
                    <span className="tw-font-medium">{tier.title}</span>
                    <img src={ArrowDownIcon} alt="Arrow Down Icon" />
                  </button>

                  {expandedSection === tier.id && (
                    <div className="tw-p-4 tw-bg-white tw-border-t">
                      <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3 xl:tw-grid-cols-4 tw-gap-4">
                        {tier.items.map((item, index) => (
                          <div
                            key={index}
                            className="tw-px-4 tw-py-3 tw-bg-white tw-rounded-lg tw-border tw-border-[#E9EAEB]"
                          >
                            <div className="tw-flex tw-justify-between tw-gap-2">
                              <div className="tw-flex tw-gap-4">
                                <img
                                  src={item.logo} // Use logo from the item object
                                  alt="logo"
                                  className="tw-w-10 tw-h-10 tw-rounded-full"
                                />
                                <div>
                                  <h6 className="tw-text-[#232323] tw-text-base tw-font-semibold tw-mb-1">
                                    {item.name}
                                  </h6>
                                  <p className="tw-text-[#475569] tw-text-sm tw-font-normal tw-mb-3">
                                    Role 1
                                  </p>
                                  <div className="tw-flex tw-items-center tw-gap-3 tw-mb-3">
                                    <img
                                      src={PhoneIcon}
                                      alt=""
                                      className="tw-w-6 tw-h-6"
                                    />
                                    <span className="tw-text-[#232323] tw-text-sm tw-font-normal">
                                      +27 81 234 5678
                                    </span>
                                  </div>
                                  <div className="tw-flex tw-items-center tw-gap-3 tw-mb-3">
                                    <img
                                      src={EmailIcon}
                                      alt=""
                                      className="tw-w-6 tw-h-6"
                                    />
                                    <span className="tw-text-[#232323] tw-text-sm tw-font-normal">
                                      alicesmith@gmail.com
                                    </span>
                                  </div>
                                </div>
                              </div>

                              <div>
                                <img
                                  src={LiveChatIcon}
                                  alt="icon"
                                  className="tw-w-6 tw-h-6"
                                />
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                      {tier.items.length === 0 && (
                        <div className="tw-text-gray-500 tw-text-center tw-py-4">
                          No items available
                        </div>
                      )}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>

        {isViewTermsSheetModalOpen && (
          <ViewTermsSheetModal
            onClose={handleCloseTermsSheet} // Correct modal close handling
          />
        )}

        {isRejectionModalOpen && (
          <TierConfigurationRejectionReason
            onClose={handleCloseRejectionModal}
            onSubmit={handleRejectionSubmit}
          />
        )}
      </div>
    </div>
  );
};

export default TierConfigurationModule;
